import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const KategoriePrac = {
	name: NAME,
	apiProvider,
	router,
};
